var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103,
    height: 40,
    viewBox: "0 0 103 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.1,
    d: "M82.222 40c11.046 0 20-8.954 20-20s-8.954-20-20-20c-11.045 0-20 8.954-20 20s8.955 20 20 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.948 26.646c2.794 0 4.408-1.22 5.606-2.879l-2.65-1.895c-.761.93-1.541 1.549-2.866 1.549-1.778 0-3.03-1.494-3.03-3.408v-.036c0-1.859 1.252-3.39 3.03-3.39 1.216 0 2.05.602 2.776 1.495l2.65-2.06c-1.126-1.548-2.795-2.642-5.39-2.642-3.846 0-6.676 2.916-6.676 6.633v.037c0 3.808 2.92 6.596 6.55 6.596zm11.643-.255h3.683l.907-2.296h4.917l.907 2.296h3.774l-5.406-12.847H23.98L18.59 26.391zm5.625-5.047l1.433-3.608 1.415 3.608h-2.848zm15.417 5.047h3.52v-3.863h1.56l2.558 3.863h4.046l-3.03-4.446c1.579-.674 2.613-1.968 2.613-3.936v-.037c0-1.257-.381-2.223-1.125-2.97-.853-.856-2.195-1.366-4.137-1.366h-6.005V26.39zm3.52-6.633v-3.08h2.322c1.161 0 1.905.51 1.905 1.531v.037c0 .93-.707 1.512-1.887 1.512h-2.34zm39.07-6.425c3.681 0 6.666 2.985 6.666 6.667s-2.985 6.667-6.667 6.667-6.666-2.985-6.666-6.667 2.984-6.667 6.666-6.667zm-13.493.303v3.097h-3.81v9.658H61.4v-9.658H57.61v-3.097H68.73z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartoLogo);
export default __webpack_public_path__ + "static/media/carto-logo.60ee54a6db4c4c860ba5723a5c8ce9da.svg";
export { ForwardRef as ReactComponent };